import { apiClient } from "./client";

export type UnavailabilityKind = "VACATION" | "TRAINING" | "SICK_LEAVE" | "OTHER";
export type UnavailabilityStatus = "PENDING" | "APPROVED" | "REJECTED" | "CANCELLED";

export type Unavailability = {
  id: string;
  practitioner_id: string;
  practitioner_display_name: string | null;
  kind: UnavailabilityKind;
  date_from: string;
  date_to: string;
  status: UnavailabilityStatus;
  reason: string | null;
  decision_reason: string | null;
  decided_at: string | null;
  decided_by_user_id: string | null;
  created_at: string;
  updated_at: string;
};

export type UnavailabilityCreatePayload = {
  kind: UnavailabilityKind;
  date_from: string;
  date_to: string;
  reason?: string | null;
};

export async function listMyUnavailabilities(): Promise<Unavailability[]> {
  const { data } = await apiClient.get<Unavailability[]>("/api/v1/me/unavailabilities");
  return data;
}

export async function createMyUnavailability(
  p: UnavailabilityCreatePayload,
): Promise<Unavailability> {
  const { data } = await apiClient.post<Unavailability>("/api/v1/me/unavailabilities", p);
  return data;
}

export async function cancelMyUnavailability(id: string): Promise<void> {
  await apiClient.delete(`/api/v1/me/unavailabilities/${id}`);
}

export async function listAllUnavailabilities(params: {
  status?: UnavailabilityStatus;
  practitioner_id?: string;
}): Promise<Unavailability[]> {
  const { data } = await apiClient.get<Unavailability[]>("/api/v1/unavailabilities", {
    params,
  });
  return data;
}

export async function approveUnavailability(
  id: string,
  decisionReason?: string,
): Promise<Unavailability> {
  const { data } = await apiClient.post<Unavailability>(
    `/api/v1/unavailabilities/${id}/approve`,
    { decision_reason: decisionReason ?? null },
  );
  return data;
}

export async function rejectUnavailability(
  id: string,
  decisionReason?: string,
): Promise<Unavailability> {
  const { data } = await apiClient.post<Unavailability>(
    `/api/v1/unavailabilities/${id}/reject`,
    { decision_reason: decisionReason ?? null },
  );
  return data;
}

export type LeaveBalance = {
  year: number;
  practitioner_id: string;
  allocation_days: number;
  consumed_days: number;
  pending_days: number;
  remaining_days: number;
};

export async function getMyLeaveBalance(year?: number): Promise<LeaveBalance> {
  const { data } = await apiClient.get<LeaveBalance>("/api/v1/me/leave-balance", {
    params: year ? { year } : {},
  });
  return data;
}
